import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { turnitinRequest, turnitinFailure, turnitinSuccess, turnitinDoSubmissionRequest, turnitinGetEulaRequest } from '../reducers/turnitin';

import { API_LINK } from '../../constants';
import {
  buildTurnitinSubmissionPayload,
  resolveTurnitinAssessmentContext,
} from '../../utils/buildTurnitinSubmissionPayload';

const API = `${API_LINK}api`;

function* turnitinRequestFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user,
    token,
  } = state.loginReducer;

  const {
    request_id,
    eulaVersion,
    eulaAcceptedTimestamp,
    eulaLanguage,
  } = state.turnitinReducer;
  const assessmentContext = resolveTurnitinAssessmentContext(state);
  const eula = eulaVersion && eulaAcceptedTimestamp
    ? {
      version: eulaVersion,
      accepted_timestamp: eulaAcceptedTimestamp,
      language: eulaLanguage,
    }
    : null;
  const data = JSON.stringify(
    buildTurnitinSubmissionPayload({ user, assessmentContext, request_id, eula }),
  );

  const response = yield call(() =>
    axios({
      method: 'post',
      url: API+'/assessor/tii_requestSubmission',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        tii_data: data
      },
    }),
  );

  return response;
}

function* workerTurnitinRequestSaga() {
  try {
    const response = yield call(turnitinRequestFunctionAxios);
    const responseFromTurnitinRequest = response.data;
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('[Turnitin] tii_requestSubmission status:', response.status, 'body:', responseFromTurnitinRequest);
    }
    if (response.status === 200) {
      const succeeded = responseFromTurnitinRequest.success !== false;
      const eulaRequired = !succeeded
        && (responseFromTurnitinRequest.reason == null
          || responseFromTurnitinRequest.reason === 'eula_required');

      if (succeeded) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('[Turnitin] success → skipping EULA, going to upload');
        }
        yield put(turnitinSuccess(responseFromTurnitinRequest));
        yield put(turnitinDoSubmissionRequest())
      } else if (eulaRequired) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('[Turnitin] eula_required → dispatching turnitinGetEulaRequest (EULA flow)');
        }
        yield put(turnitinGetEulaRequest());
      } else {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('[Turnitin] submission failed (not EULA):', responseFromTurnitinRequest.reason, '→ stopping, will not reopen EULA');
        }
        yield put(turnitinFailure(responseFromTurnitinRequest.reason || 'Turnitin submission failed'));
      }
    }
    if (response.status === 201) {
      yield put(turnitinFailure(responseFromTurnitinRequest.message));
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('[Turnitin] tii_requestSubmission threw (non-2xx → EULA never shown):', error.response && error.response.status, error.message, error.response && error.response.data);
    }
    yield put(turnitinFailure(error.message));
  }
}

export function* watcherTurnitinRequestSaga() {
  yield takeLatest(turnitinRequest().type, workerTurnitinRequestSaga);
}
